import { AllStatusProject } from '@app/interfaces/analytics';
import {
  MetricTypesArrType,
  MetricObjType,
} from '@app/interfaces/pages-types/anatylics-metric.type';
import React, { FC } from 'react';

import { useGetAliasesListQuery } from '@app/store/api/alias-settings-page.api';

import MetaMetricModal from './meta-metric-modal';
import MetaMetricCreateTable from './meta-metric-create-table';

type MetaMetricWrapperPropsType = {
  metric: MetricTypesArrType;
  editModal?: boolean;
  copyModal?: boolean;
  modalsSetState: (type: string) => void;
  status?: AllStatusProject | undefined;
  unitVal?: string;
  metricSettings?: MetricObjType | undefined;
  currentTemplate: 'chat' | 'voice';
};

const MetaMetricWrapper: FC<MetaMetricWrapperPropsType> = (props) => {
  const { data: aliases } = useGetAliasesListQuery();
  if (props.editModal || props.copyModal)
    return <MetaMetricModal aliases={aliases?.aliases || []} {...props} />;
  return <MetaMetricCreateTable aliases={aliases?.aliases || []} {...props} />;
};

export default MetaMetricWrapper;
